var _path, _path2, _path3, _path4, _path5, _path6, _polygon, _path7, _polygon2, _path8, _path9, _path10, _polygon3, _path11, _path12, _path13, _path14, _path15, _path16, _circle, _path17, _path18, _path19, _path20, _path21, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductivity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b441d19d-62db-4735-9de7-1350ff0a1aa5",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 664.14567,
    height: 573.57499,
    viewBox: "0 0 664.14567 573.57499",
    className: "w-full sm:w-3/4 xl:w-3/4 lg:w-full max-w-full h-auto max-h-96 block float-left lg:float-unset",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pinboard Planner Productivity Image") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M349.78153,229.21251a33,33,0,1,1,33-33h0A33.03734,33.03734,0,0,1,349.78153,229.21251Zm0-64a31,31,0,1,0,31,31A31,31,0,0,0,349.78153,165.21251Z",
    transform: "translate(-267.92717 -163.21251)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M519.78153,262.21251a33,33,0,1,1,33-33h0A33.03734,33.03734,0,0,1,519.78153,262.21251Zm0-64a31,31,0,1,0,31,31A31,31,0,0,0,519.78153,198.21251Z",
    transform: "translate(-267.92717 -163.21251)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M396.78153,370.21251a33,33,0,1,1,33-33h0A33.03734,33.03734,0,0,1,396.78153,370.21251Zm0-64a31,31,0,1,0,31,31A31,31,0,0,0,396.78153,306.21251Z",
    transform: "translate(-267.92717 -163.21251)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M301.078,250.2818V194.375h48.84916V250.2818Z",
    transform: "translate(-267.92717 -163.21251)",
    fill: "#007bff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M372.50474,393.06449V337.15764H421.3539v55.90685Z",
    transform: "translate(-267.92717 -163.21251)",
    fill: "#007bff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M520.03365,282.84169V226.93484h48.84916v55.90685Z",
    transform: "translate(-267.92717 -163.21251)",
    fill: "#007bff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "511.775 559.294 498.307 559.293 491.901 507.348 511.777 507.348 511.775 559.294",
    fill: "#ffb8b8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M783.13632,735.56065,739.712,735.559v-.54925A16.90285,16.90285,0,0,1,756.614,718.10812h.00107l26.52208.00107Z",
    transform: "translate(-267.92717 -163.21251)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "450.456 559.294 436.989 559.293 430.582 507.348 450.458 507.348 450.456 559.294",
    fill: "#ffb8b8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M721.8178,735.56065l-43.42429-.00161v-.54925a16.90285,16.90285,0,0,1,16.90194-16.90167h.00108l26.52208.00107Z",
    transform: "translate(-267.92717 -163.21251)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M775.861,493.80621a11.119,11.119,0,0,1,11.93017-12.1804l11.53316-22.64058,15.468,3.653-16.73611,31.74413a11.17926,11.17926,0,0,1-22.19523-.57612Z",
    transform: "translate(-267.92717 -163.21251)",
    fill: "#ffb8b8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M713.01139,532.574a11.119,11.119,0,0,0-3.07854-16.76942l3.10028-25.219-14.866-5.62189-3.878,35.67559A11.17926,11.17926,0,0,0,713.01139,532.574Z",
    transform: "translate(-267.92717 -163.21251)",
    fill: "#ffb8b8"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "515.645 292.356 531.886 342.806 521.574 419.622 514.459 548.872 486 546.5 486 429.108 482.686 362.704 466.628 450.452 454.528 545.786 426.54 546.014 437.383 344.918 442.126 293.929 515.645 292.356",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M760.44914,349.82891,745.034,355.7578l-15.41512-3.55733-7.70755,115.61336s46.24534,21.344,53.36-4.74312S760.44914,349.82891,760.44914,349.82891Z",
    transform: "translate(-267.92717 -163.21251)",
    fill: "#ccc"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M795.42959,358.72225l-26.08711-2.37156-9.27158-6.76954-7.32931,67.24422s10.672,68.77513,30.83022,75.8898l15.41512-24.90134s-2.37156-21.344-13.04356-29.64445Z",
    transform: "translate(-267.92717 -163.21251)",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M700.56735,365.83692l23.72957-7.86881,5.322-5.76764s13.63645,140.5147,8.89334,142.88625-35.57334,4.74311-35.57334,4.74311Z",
    transform: "translate(-267.92717 -163.21251)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M785.94337,368.20847l9.48622-9.48622s36.75912,77.07557,34.38757,81.81868-20.15823,39.13068-20.15823,39.13068l-15.41511-17.78667,11.85778-32.016-22.52979-28.45867Z",
    transform: "translate(-267.92717 -163.21251)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M707.682,368.20847l-7.11467-2.37155a13.9747,13.9747,0,0,0-5.92889,11.85778c0,8.30044-1.18578,132.80714-1.18578,132.80714H713.3168Z",
    transform: "translate(-267.92717 -163.21251)",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M706.43512,311.06521a37.55142,37.55142,0,0,1,18.41854-32.18672c11.8831-7.01524,26.2201-6.88812,39.33418.347,9.34336,5.15563,16.94485,18.12783,16.94485,28.91753v31.483H706.43512Z",
    transform: "translate(-267.92717 -163.21251)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 742.30471,
    cy: 311.86988,
    r: 26.98014,
    transform: "translate(-326.55254 231.05945) rotate(-28.66318)",
    fill: "#ffb8b8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M714.16909,312.12509c-.20436-.236-.68307-.789,2.64486-26.39657l.10567-.41837h.3009c16.869-8.29878,33.98358-8.50743,50.87239-.62327a3.323,3.323,0,0,1,1.88374,2.68884c1.97091,24.05905,1.49461,24.58363,1.29105,24.80783a3.30385,3.30385,0,0,1-2.43889,1.07865h-7.48295l-.15689-.28267a77.22636,77.22636,0,0,0-4.22287-6.945,61.64151,61.64151,0,0,0-1.72418,6.79049l-.09118.43715h-38.491A3.2945,3.2945,0,0,1,714.16909,312.12509Z",
    transform: "translate(-267.92717 -163.21251)",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M931.07283,736.78749h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-267.92717 -163.21251)",
    fill: "#ccc"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "f8574534-e24e-408e-9d08-1b03903fb5c9",
    "data-name": "Path 293",
    d: "M317.74074,735.21744l-.51916-.16161c-.18692-.05842-18.74339-6.01915-28.12351-21.33208s-6.25859-34.55278-6.22615-34.74552l.09019-.53346.51916.16161c.18692.05842,18.74339,6.01916,28.12351,21.33275h0c9.37947,15.31554,6.25859,34.55215,6.22615,34.74489Zm-34.01417-55.53055c-.427,3.22925-2.12989,19.97771,6.17942,33.54365s24.00323,19.65777,27.07349,20.74478c.427-3.22925,2.12989-19.9777-6.17941-33.543h0C302.49333,686.869,286.79683,680.7739,283.72657,679.68689Z",
    transform: "translate(-267.92717 -163.21251)",
    fill: "#ccc"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M389.20655,736.78749H268.79345a1.01032,1.01032,0,0,1,0-2h120.4131a1.01032,1.01032,0,0,1,0,2Z",
    transform: "translate(-267.92717 -163.21251)",
    fill: "#ccc"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "a3f825ef-0915-48ed-bc51-13344214e9a0",
    "data-name": "Path 292",
    d: "M323.52884,700.18507c-9.39572,15.33958-6.16516,34.41977-6.16516,34.41977s18.46624-5.78942,27.862-21.129,6.16516-34.41977,6.16516-34.41977S332.92456,684.84616,323.52884,700.18507Z",
    transform: "translate(-267.92717 -163.21251)",
    fill: "#e6e6e6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "b0302f70-fb56-40b5-b603-5b52e4f140d6",
    "data-name": "Ellipse 48",
    cx: 50.02517,
    cy: 511.30604,
    r: 10.38148,
    fill: "#e6e6e6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductivity);
export default __webpack_public_path__ + "static/media/productivity.37851970618ca5cdbd699ff2692b3208.svg";
export { ForwardRef as ReactComponent };